import list from 'src/modules/formTemplate/list/formTemplateListReducers';
import form from 'src/modules/formTemplate/form/formTemplateFormReducers';
import view from 'src/modules/formTemplate/view/formTemplateViewReducers';
import destroy from 'src/modules/formTemplate/destroy/formTemplateDestroyReducers';
import importerReducer from 'src/modules/formTemplate/importer/formTemplateImporterReducers';
import { combineReducers } from 'redux';

export default combineReducers({
  list,
  form,
  view,
  destroy,
  importer: importerReducer,
});
